import React from 'react'
import LensIcon from '@material-ui/icons/Lens'
import GridOnIcon from '@material-ui/icons/GridOn'
import WifiTetheringIcon from '@material-ui/icons/WifiTethering'
import ExtensionIcon from '@material-ui/icons/Extension'
import EventIcon from '@material-ui/icons/Event' 
import StarIcon from '@material-ui/icons/Star'
import { WID } from './Language';

export const boardType = {
  WEB_BOARD: 'WEB_BOARD',
  LIVE_GAME: 'LIVE_GAME',
  GAME_ANALYZE: 'GAME_ANALYZE',
  PUZZLE_REGISTER: 'PUZZLE_REGISTER',
  PUZZLE_VIEWER: 'PUZZLE_VIEWER',
  VIEWER: 'VIEWER',
  GAME_ROOM: 'GAME_ROOM',
}

export const stoneType = {
  BLACK: 'black',
  WHITE: 'white',
}

export const turnType = {
  AUTO: 0,
  BLACK: 1,
  WHITE: 2,
}

export const editModeType = {
  NORMAL: 0,
  PUZZLE: 1,
}

export const operationModeType = {
  EDIT: 0,
  VIEW: 1,
  SET: 2,
}

export const userType = {
  CONTRIBUTOR: 'contributor',
  AUDIENCE: 'audience',
}

export const liveStatus = {
  OPEN: 1,
  CLOSE: 2,
  DELETE: 3,
}

export const liveListViewMode = {
  GRID: 'GRID',
  TABLE: 'TABLE',
}

export const defaultInsertStrings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export const puzzleRegisterStepperType = {
  STEP1_INFO: 0,
  STEP2_PUZZLE: 1,
  STEP3_ANSWER: 2,
  STEP4_CONFIRM: 3,
}

export const puzzleTypeItems = [
  { value: '',    wid: '', label: '' },
  { value: 'VCT', wid: WID.PUZZLE_TYPE_ITEMS.VCT, label: '追い詰め' },
  { value: 'VCF', wid: WID.PUZZLE_TYPE_ITEMS.VCF, label: '四追い' },
]

export const puzzleLevelItems = [
  { value: '',  label: '', helperText: '', wid: '' },
  { value: '1', label: <React.Fragment><StarIcon/></React.Fragment>, helperText: '初心者向け', wid: WID.PUZZLE_LEVEL_ITEMS.FOR_BEGINNER },
  { value: '2', label: <React.Fragment><StarIcon/><StarIcon/></React.Fragment>, helperText: '級位者向け(10級～4級)', wid: WID.PUZZLE_LEVEL_ITEMS.FOR_LOW_KYU_PLAYER },
  { value: '3', label: <React.Fragment><StarIcon/><StarIcon/><StarIcon/></React.Fragment>, helperText: '級位者向け(3級～1級)', wid: WID.PUZZLE_LEVEL_ITEMS.FOR_HIGH_KYU_PLAYER },
  { value: '4', label: <React.Fragment><StarIcon/><StarIcon/><StarIcon/><StarIcon/></React.Fragment>, helperText: '低段者向け', wid: WID.PUZZLE_LEVEL_ITEMS.FOR_LOW_DAN_PLAYER },
  { value: '5', label: <React.Fragment><StarIcon/><StarIcon/><StarIcon/><StarIcon/><StarIcon/></React.Fragment>, helperText: '高段者向け', wid: WID.PUZZLE_LEVEL_ITEMS.FOR_HIGH_DAN_PLAYER },
]

export const puzzleOtherAnswersItems = [
  { value: 0, label: 'なし', wid: WID.PUZZLE_REGISTER.STEPPER4.OTHER_ANSWERS_NO },
  { value: 1, label: 'あり', wid: WID.PUZZLE_REGISTER.STEPPER4.OTHER_ANSWERS_YES },
]

export const puzzleTurnItems = [
  { value: turnType.AUTO,  label: 'AUTO', wid: WID.PUZZLE_TURN_ITEMS.AUTO },
  { value: turnType.BLACK, label: '黒先', wid: WID.PUZZLE_TURN_ITEMS.BLACK },
  { value: turnType.WHITE, label: '白先', wid: WID.PUZZLE_TURN_ITEMS.WHITE },
]

export const puzzleTurnItemsForCaro = [
  { value: turnType.AUTO,  label: 'AUTO', wid: WID.PUZZLE_TURN_ITEMS.AUTO },
  { value: turnType.BLACK, label: '黒先', wid: WID.PUZZLE_TURN_ITEMS.CROSS },
  { value: turnType.WHITE, label: '白先', wid: WID.PUZZLE_TURN_ITEMS.CIRCLE },
]

export const OPENING_RULE = {
  NONE: '',
  FREE: 'FREE',
  SOOSYRV8: 'SOOSYRV8',
}

export const openingRuleItems = [
  {
    value: OPENING_RULE.NONE,
    label: '',
    player1Label: '先手',
    player2Label: '後手',
    short: '',
    wid: '',
    player1wid: WID.OPENING_RULE_ITEMS.PLAYER_FIRST_1,
    player2wid: WID.OPENING_RULE_ITEMS.PLAYER_SECOND_1,
  },
  {
    value: OPENING_RULE.FREE,
    label: '自由打ち',
    player1Label: '先手',
    player2Label: '後手',
    short: '',
    wid: WID.OPENING_RULE_ITEMS.FREE,
    player1wid: WID.OPENING_RULE_ITEMS.PLAYER_FIRST_1,
    player2wid: WID.OPENING_RULE_ITEMS.PLAYER_SECOND_1,
  },
  {
    value: OPENING_RULE.SOOSYRV8,
    label: 'ソーソロフ8',
    player1Label:'仮先',
    player2Label: '仮後',
    short: 's8',
    wid: WID.OPENING_RULE_ITEMS.SOOSYRV8,
    player1wid: WID.OPENING_RULE_ITEMS.PLAYER_FIRST_2,
    player2wid: WID.OPENING_RULE_ITEMS.PLAYER_SECOND_2,
  },
]

export const UNDO_SETTING = {
  OK: "1",
  NG: "0",
}

export const undoItems = [
  {
    value: UNDO_SETTING.OK,
    label: 'あり',
    wid: WID.UNDO_ITEMS.OK,
  },
  {
    value: UNDO_SETTING.NG,
    label: 'なし',
    wid: WID.UNDO_ITEMS.NG,
  }
]

export const TURN_SETTING = {
  RANDOM: 'RANDOM',
  FIRST: 'FIRST',
  SECOND: 'SECOND',
}

export const turnItems = [
  {
    value: TURN_SETTING.RANDOM,
    label: 'ランダム',
    wid: WID.TURN_ITEMS.RANDOM,
    wid2: WID.TURN_ITEMS.RANDOM,
  },
  {
    value: TURN_SETTING.FIRST,
    label: 'あなたが先手',
    wid: WID.TURN_ITEMS.FIRST,
    wid2: WID.TURN_ITEMS.SECOND,
  },
  {
    value: TURN_SETTING.SECOND,
    label: 'あなたが後手',
    wid: WID.TURN_ITEMS.SECOND,
    wid2: WID.TURN_ITEMS.FIRST,
  }
]

export const gameResultsItems = [
  { value: '', label: '', wid: '' },
  { value: 'BlackWin', label: '白投了', wid: WID.GAME_RESULT_ITEMS.WHITE_PLAYER_RESIGN },
  { value: 'WhiteWin', label: '黒投了', wid: WID.GAME_RESULT_ITEMS.BLACK_PLAYER_RESIGN },
  { value: 'Draw', label: '満局', wid: WID.GAME_RESULT_ITEMS.DRAW },
];

export const SKIN = {
  DEFAULT: 'default',
  CARO: 'caro',
}

export const initialSettings = {
  isVisibleCoordinate: true,
  isVisibleNumber: true,
  isVisibleForbidden: true,
  isVisibleNextMove: true,
  isVisibleLastMoveMark: true,
  isVisibleGameInfo: true,
  isVisibleTitle: true,
  isVisiblePlayerName: true,
  isVisibleGameResult: true,
  skin: SKIN.DEFAULT,
}

export const initialSoosyrv8 = {
  swap1: undefined,
  swap2: undefined,
  fiveMoveNumber: 1,
  fiveMoves: []
}

export const webBoardModeType = {
  EDIT: 'EDIT',
  FOLDER: 'FOLDER'
}

export const decisionType = {
  SOOSYRV8_SWAP1: 'SOOSYRV8_SWAP1',
  SOOSYRV8_FIVE_MOVE_NUMBER: 'SOOSYRV8_FIVE_MOVE_NUMBER',
  SOOSYRV8_SWAP2: 'SOOSYRV8_SWAP2',
  SOOSYRV8_FIVE_MOVES: 'SOOSYRV8_FIVE_MOVES',
}

export const RANK_TYPES = {
  NONE: '',
  DAN: 'DAN',
  KYU: 'KYU',
}

export const rankItems = [
  { value: '9d', label: '九段', type: RANK_TYPES.DAN, number: 9 },
  { value: '8d', label: '八段', type: RANK_TYPES.DAN, number: 8 },
  { value: '7d', label: '七段', type: RANK_TYPES.DAN, number: 7 },
  { value: '6d', label: '六段', type: RANK_TYPES.DAN, number: 6 },
  { value: '5d', label: '五段', type: RANK_TYPES.DAN, number: 5 },
  { value: '4d', label: '四段', type: RANK_TYPES.DAN, number: 4 },
  { value: '3d', label: '三段', type: RANK_TYPES.DAN, number: 3 },
  { value: '2d', label: '二段', type: RANK_TYPES.DAN, number: 2 },
  { value: '1d', label: '初段', type: RANK_TYPES.DAN, number: 1 },
  { value: '', label: '', type: RANK_TYPES.NONE },
  { value: '1k', label: '１級', type: RANK_TYPES.KYU, number: 1 },
  { value: '2k', label: '２級', type: RANK_TYPES.KYU, number: 2 },
  { value: '3k', label: '３級', type: RANK_TYPES.KYU, number: 3 },
  { value: '4k', label: '４級', type: RANK_TYPES.KYU, number: 4 },
  { value: '5k', label: '５級', type: RANK_TYPES.KYU, number: 5 },
  { value: '6k', label: '６級', type: RANK_TYPES.KYU, number: 6 },
  { value: '7k', label: '７級', type: RANK_TYPES.KYU, number: 7 },
  { value: '8k', label: '８級', type: RANK_TYPES.KYU, number: 8 },
  { value: '9k', label: '９級', type: RANK_TYPES.KYU, number: 9 },
  { value: '10k', label: '１０級', type: RANK_TYPES.KYU, number: 10 },
]

export const countryItems = [
  { value: 'AD', label: 'アンドラ' },
  { value: 'AE', label: 'アラブ首長国連邦' },
  { value: 'AF', label: 'アフガニスタン' },
  { value: 'AG', label: 'アンティグア・バーブーダ' },
  { value: 'AI', label: 'アンギラ' },
  { value: 'AL', label: 'アルバニア' },
  { value: 'AM', label: 'アルメニア' },
  { value: 'AO', label: 'アンゴラ' },
  { value: 'AQ', label: '南極' },
  { value: 'AR', label: 'アルゼンチン' },
  { value: 'AS', label: 'アメリカ領サモア' },
  { value: 'AT', label: 'オーストリア' },
  { value: 'AU', label: 'オーストラリア' },
  { value: 'AW', label: 'アルバ' },
  { value: 'AZ', label: 'アゼルバイジャン' },
  { value: 'BA', label: 'ボスニア・ヘルツェゴビナ' },
  { value: 'BB', label: 'バルバドス' },
  { value: 'BD', label: 'バングラデシュ' },
  { value: 'BE', label: 'ベルギー' },
  { value: 'BF', label: 'ブルキナファソ' },
  { value: 'BG', label: 'ブルガリア' },
  { value: 'BH', label: 'バーレーン' },
  { value: 'BI', label: 'ブルンジ' },
  { value: 'BJ', label: 'ベナン' },
  { value: 'BL', label: 'セント・バーツ' },
  { value: 'BM', label: 'バミューダ諸島' },
  { value: 'BN', label: 'ブルネイ' },
  { value: 'BO', label: 'ボリビア' },
  { value: 'BR', label: 'ブラジル' },
  { value: 'BS', label: 'バハマ' },
  { value: 'BT', label: 'ブータン' },
  { value: 'BV', label: 'ブーベ島' },
  { value: 'BW', label: 'ボツワナ' },
  { value: 'BY', label: 'ベラルーシ' },
  { value: 'BZ', label: 'ベリーズ' },
  { value: 'CA', label: 'カナダ' },
  { value: 'CC', label: 'ココス (キーリング) 諸島' },
  { value: 'CD', label: 'コンゴ民主共和国' },
  { value: 'CF', label: '中央アフリカ共和国' },
  { value: 'CG', label: 'コンゴ共和国' },
  { value: 'CH', label: 'スイス' },
  { value: 'CI', label: 'コートジボワール' },
  { value: 'CK', label: 'クック諸島' },
  { value: 'CL', label: 'チリ' },
  { value: 'CM', label: 'カメルーン' },
  { value: 'CN', label: '中国' },
  { value: 'CO', label: 'コロンビア' },
  { value: 'CR', label: 'コスタリカ' },
  { value: 'CU', label: 'キューバ' },
  { value: 'CV', label: 'カーボベルデ' },
  { value: 'CW', label: 'キュラソー' },
  { value: 'CX', label: 'クリスマス島' },
  { value: 'CY', label: 'キプロス' },
  { value: 'CZ', label: 'チェコ共和国' },
  { value: 'DE', label: 'ドイツ' },
  { value: 'DJ', label: 'ジブチ' },
  { value: 'DK', label: 'デンマーク' },
  { value: 'DM', label: 'ドミニカ国' },
  { value: 'DO', label: 'ドミニカ共和国' },
  { value: 'DZ', label: 'アルジェリア' },
  { value: 'EC', label: 'エクアドル' },
  { value: 'EE', label: 'エストニア' },
  { value: 'EG', label: 'エジプト' },
  { value: 'EH', label: '西サハラ' },
  { value: 'ER', label: 'エリトリア' },
  { value: 'ES', label: 'スペイン' },
  { value: 'ET', label: 'エチオピア' },
  { value: 'FI', label: 'フィンランド' },
  { value: 'FJ', label: 'フィジー' },
  { value: 'FK', label: 'フォークランド諸島 (マルビナス諸島)' },
  { value: 'FM', label: 'ミクロネシア連邦' },
  { value: 'FO', label: 'フェロー諸島' },
  { value: 'FR', label: 'フランス' },
  { value: 'FX', label: 'フランス本土' },
  { value: 'GA', label: 'ガボン' },
  { value: 'GB', label: '英国' },
  { value: 'GD', label: 'グレナダ' },
  { value: 'GE', label: 'グルジア' },
  { value: 'GF', label: 'フランス領ギアナ' },
  { value: 'GG', label: 'ガーンジー' },
  { value: 'GH', label: 'ガーナ' },
  { value: 'GI', label: 'ジブラルタル' },
  { value: 'GL', label: 'グリーンランド' },
  { value: 'GM', label: 'ガンビア' },
  { value: 'GN', label: 'ギニア' },
  { value: 'GP', label: 'グアドループ' },
  { value: 'GQ', label: '赤道ギニア' },
  { value: 'GR', label: 'ギリシャ' },
  { value: 'GS', label: '南グルジアおよび諸島' },
  { value: 'GT', label: 'グアテマラ' },
  { value: 'GU', label: 'グアム' },
  { value: 'GW', label: 'ギニアビサウ' },
  { value: 'GY', label: 'ガイアナ' },
  { value: 'HK', label: '香港' },
  { value: 'HM', label: 'ハード島トマクドナルド諸島' },
  { value: 'HN', label: 'ホンジュラス' },
  { value: 'HR', label: 'クロアチア' },
  { value: 'HT', label: 'ハイチ' },
  { value: 'HU', label: 'ハンガリー' },
  { value: 'ID', label: 'インドネシア' },
  { value: 'IE', label: 'アイルランド' },
  { value: 'IL', label: 'イスラエル' },
  { value: 'IM', label: 'マン島' },
  { value: 'IN', label: 'インド' },
  { value: 'IO', label: '英領インド洋植民地' },
  { value: 'IQ', label: 'イラク' },
  { value: 'IR', label: 'イラン' },
  { value: 'IS', label: 'アイスランド' },
  { value: 'IT', label: 'イタリア' },
  { value: 'JE', label: 'ジャージー' },
  { value: 'JM', label: 'ジャマイカ' },
  { value: 'JO', label: 'ヨルダン' },
  { value: 'JP', label: '日本' },
  { value: 'KE', label: 'ケニア' },
  { value: 'KG', label: 'キルギス' },
  { value: 'KH', label: 'カンボジア' },
  { value: 'KI', label: 'キリバス' },
  { value: 'KM', label: 'コモロ' },
  { value: 'KN', label: 'セントクリストファー・ネイビス' },
  { value: 'KP', label: '北朝鮮' },
  { value: 'KR', label: '韓国' },
  { value: 'KW', label: 'クウェート' },
  { value: 'KY', label: 'ケイマン諸島' },
  { value: 'KZ', label: 'カザフスタン' },
  { value: 'LA', label: 'ラオス' },
  { value: 'LB', label: 'レバノン' },
  { value: 'LC', label: 'セントルシア' },
  { value: 'LI', label: 'リヒテンシュタイン' },
  { value: 'LK', label: 'スリランカ' },
  { value: 'LR', label: 'リベリア' },
  { value: 'LS', label: 'レソト' },
  { value: 'LT', label: 'リトアニア' },
  { value: 'LU', label: 'ルクセンブルク' },
  { value: 'LV', label: 'ラトビア' },
  { value: 'LY', label: 'リビア' },
  { value: 'MA', label: 'モロッコ' },
  { value: 'MC', label: 'モナコ' },
  { value: 'MD', label: 'モルドバ' },
  { value: 'ME', label: 'モンテネグロ' },
  { value: 'MF', label: 'セント・マーチン島' },
  { value: 'MG', label: 'マダガスカル' },
  { value: 'MH', label: 'マーシャル諸島' },
  { value: 'MK', label: 'マケドニア' },
  { value: 'ML', label: 'マリ' },
  { value: 'MM', label: 'ビルマ' },
  { value: 'MN', label: 'モンゴル' },
  { value: 'MO', label: 'マカオ' },
  { value: 'MP', label: '北マリアナ諸島' },
  { value: 'MQ', label: 'マルティニーク' },
  { value: 'MR', label: 'マーリタニア' },
  { value: 'MS', label: 'モントセラト' },
  { value: 'MT', label: 'マルタ' },
  { value: 'MU', label: 'モーリシャス' },
  { value: 'MV', label: 'モルジブ' },
  { value: 'MW', label: 'マラウィ' },
  { value: 'MX', label: 'メキシコ' },
  { value: 'MY', label: 'マレーシア' },
  { value: 'MZ', label: 'モザンビーク' },
  { value: 'NA', label: 'ナミビア' },
  { value: 'NC', label: 'ニューカレドニア' },
  { value: 'NE', label: 'ニジェール' },
  { value: 'NF', label: 'ノーフォーク島' },
  { value: 'NG', label: 'ナイジェリア' },
  { value: 'NI', label: 'ニカラグア' },
  { value: 'NL', label: 'オランダ' },
  { value: 'NO', label: 'ノルウェー' },
  { value: 'NP', label: 'ネパール' },
  { value: 'NR', label: 'ナウル' },
  { value: 'NU', label: 'ニウエ' },
  { value: 'NZ', label: 'ニュージーランド' },
  { value: 'OM', label: 'オマーン' },
  { value: 'PA', label: 'パナマ' },
  { value: 'PE', label: 'ペルー' },
  { value: 'PF', label: 'フランス領ポリネシア' },
  { value: 'PG', label: 'パプアニューギニア' },
  { value: 'PH', label: 'フィリピン' },
  { value: 'PK', label: 'パキスタン' },
  { value: 'PL', label: 'ポーランド' },
  { value: 'PM', label: 'サンピエール島とミクロン島' },
  { value: 'PN', label: 'ピトケアン島' },
  { value: 'PR', label: 'プエルトリコ' },
  { value: 'PS', label: 'ガザ地区' },
  { value: 'PS', label: 'ヨルダン川西岸' },
  { value: 'PT', label: 'ポルトガル' },
  { value: 'PW', label: 'パラオ' },
  { value: 'PY', label: 'パラグアイ' },
  { value: 'QA', label: 'カタール' },
  { value: 'RE', label: 'レユニオン' },
  { value: 'RO', label: 'ルーマニア' },
  { value: 'RS', label: 'セルビア' },
  { value: 'RU', label: 'ロシア' },
  { value: 'RW', label: 'ルワンダ' },
  { value: 'SA', label: 'サウジアラビア' },
  { value: 'SB', label: 'ソロモン諸島' },
  { value: 'SC', label: 'セイシェル' },
  { value: 'SD', label: 'スーダン' },
  { value: 'SE', label: 'スウェーデン' },
  { value: 'SG', label: 'シンガポール' },
  { value: 'SH', label: 'セントヘレナ、アセンション島、トリスタンダクーニャ' },
  { value: 'SI', label: 'スロベニア' },
  { value: 'SJ', label: 'スバールバル諸島' },
  { value: 'SK', label: 'スロバキア' },
  { value: 'SL', label: 'シエラレオネ' },
  { value: 'SM', label: 'サンマリノ' },
  { value: 'SN', label: 'セネガル' },
  { value: 'SO', label: 'ソマリア' },
  { value: 'SR', label: 'スリナム' },
  { value: 'SS', label: '南スーダン' },
  { value: 'ST', label: 'サントメプリンシペ' },
  { value: 'SV', label: 'エルサルバドル' },
  { value: 'SX', label: 'シント・マールテン' },
  { value: 'SY', label: 'シリア' },
  { value: 'SZ', label: 'スワジランド' },
  { value: 'TC', label: 'タークス・カイコス諸島' },
  { value: 'TD', label: 'チャド' },
  { value: 'TF', label: 'フランス領南方・南極地域' },
  { value: 'TG', label: 'トーゴ' },
  { value: 'TH', label: 'タイ' },
  { value: 'TJ', label: 'タジキスタン' },
  { value: 'TK', label: 'トケラウ' },
  { value: 'TL', label: '東チモール' },
  { value: 'TM', label: 'トルクメニスタン' },
  { value: 'TN', label: 'チュニジア' },
  { value: 'TO', label: 'トンガ' },
  { value: 'TR', label: 'トルコ' },
  { value: 'TT', label: 'トリニダード・ドバゴ' },
  { value: 'TV', label: 'ツバル' },
  { value: 'TW', label: '台湾' },
  { value: 'TZ', label: 'タンザニア' },
  { value: 'UA', label: 'ウクライナ' },
  { value: 'UG', label: 'ウガンダ' },
  { value: 'UM', label: '合衆国領有小離島' },
  { value: 'US', label: '米国' },
  { value: 'UY', label: 'ウルグアイ' },
  { value: 'UZ', label: 'ウズベキスタン' },
  { value: 'VA', label: 'バチカン市国' },
  { value: 'VC', label: 'セントビンセント・グレナディーン' },
  { value: 'VE', label: 'ベネズエラ' },
  { value: 'VG', label: '英領バージン諸島' },
  { value: 'VI', label: 'バージン諸島' },
  { value: 'VN', label: 'ベトナム' },
  { value: 'VU', label: 'バヌアツ' },
  { value: 'WF', label: 'ワリー・エ・フトゥーナ諸島' },
  { value: 'WS', label: 'サモア' },
  { value: 'XK', label: 'コソボ' },
  { value: 'YE', label: 'イエメン' },
  { value: 'YT', label: 'マヨット' },
  { value: 'ZA', label: '南アフリカ' },
  { value: 'ZM', label: 'ザンビア' },
  { value: 'ZW', label: 'ジンバブエ' },
]

export const leftMenuItems = [
  { icon: (<EventIcon/>),          to: '/event',  disabled: false, wid: WID.LEFT_MENU_BAR.EVENT },
  { icon: (<WifiTetheringIcon/>),  to: '/live',   disabled: false, wid: WID.LEFT_MENU_BAR.LIVE },
  { icon: (<LensIcon/>),           to: '/game',   disabled: false, wid: WID.LEFT_MENU_BAR.ONLINE_GAME },
  { icon: (<ExtensionIcon/>),      to: '/puzzle', disabled: false, wid: WID.LEFT_MENU_BAR.PUZZLE },
  { icon: (<GridOnIcon/>),         to: '/board',  disabled: false, wid: WID.LEFT_MENU_BAR.WEB_BOARD },
]

export const authorType = {
  CONTRIBUTOR: '1',
  PROVIDER: '2',
}

export const authorTypeItems = [
  { value: authorType.CONTRIBUTOR, wid: WID.EVENT_REGISTER_CARD.ORGANIZER },
  { value: authorType.PROVIDER, wid: WID.EVENT_REGISTER_CARD.INFORMATION_PROVIDER },
]

export const gameType = {
  LIVE_GAME: 'LIVE_GAME',
  DAILY_GAME: 'DAILY_GAME',
}

export const gameTypeMenuItems = [
  { value: gameType.LIVE_GAME,         wid: WID.GAME_TYPE_MENU_ITEMS.LIVE_GAME, label: 'ライブ' },
  { value: gameType.DAILY_GAME,        wid: WID.GAME_TYPE_MENU_ITEMS.DAILY_GAME, label: 'デイリー' },
]

export const roomStatus = {
  EMPTY: 'EMPTY',
  WAIT: 'WAIT',
  PLAYING: 'PLAYING',
  END: 'END',
}

export const renjuBoardMessageType = {
  NONE: 'NONE',
  SWAP1: 'SWAP1',
  SWAP2: 'SWAP2',
  FIVE_MOVE_NUMBER: 'FIVE_MOVE_NUMBER',
  FIVE_MOVES: 'FIVE_MOVES',
  VIEW_SWAP1: 'VIEW_SWAP1',
  VIEW_SWAP2: 'VIEW_SWAP2',
  VIEW_FIVE_MOVE_NUMBER: 'VIEW_FIVE_MOVE_NUMBER',
}

export const ENDED_ACTION = {
  FIVE: 1,
  RESIGN: 2, 
  OFFER_DRAW: 3,
  TIMEOUT: 4,
}

export const RESULT_OFFER_DRAW = {
  NONE: 0,
  ACCEPT: 1,
  DENY: 2,
}

export const CHAT_TYPE = {
  MESSAGE: 'MESSAGE',
  JOIN_ROOM: 'JOIN_ROOM',
  LEAVE_ROOM: 'LEAVE_ROOM',
  FIVE: 'FIVE',
  RESIGN: 'RESIGN',
  DRAW_ACCEPT: 'DRAW_ACCEPT',
  DRAW_DENY: 'DRAW_DENY',
  GAME_START: 'GAME_START',
  GAME_RESULT: 'GAME_RESULT',
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
}

export const LANGUAGE_SHORT_CODE = {
  JA: 'ja',
  EN: 'en',
  CN: 'cn',
  TW: 'tw',
  KO: 'ko',
}

export const languageProps = [
  { value: LANGUAGE_SHORT_CODE.JA, label: '日本語' },
  { value: LANGUAGE_SHORT_CODE.EN, label: 'English' },
  { value: LANGUAGE_SHORT_CODE.CN, label: '中文简体' },
  { value: LANGUAGE_SHORT_CODE.TW, label: '中文繁體' },
  { value: LANGUAGE_SHORT_CODE.KO, label: '한국어' },
]

export const EVENT_REGISTER_RESULT = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}

export const PLAYER_TYPE = {
  PLAYER_1: 'PLAYER_1',
  PLAYER_2: 'PLAYER_2'
}


// WEBPACK FOOTER //
// ./src/constants/index.js